export default __webpack_public_path__ + "static/media/background2.8ac6f289.svg";